import Locations from './LocationsEnhanced';

export { MIN_SEARCH_INPUT_LENGTH } from './Locations';
export default Locations;
